import { useWorldStore } from '../state/worldStore';
import { ROOMS } from '../rooms';

// Point of view, and whether the player has a body to hold anything with.
//
// POV is derived from the ROOM, not stored alongside it — rooms.js already
// declares `firstPerson` for the spaces you walk through rather than orbit, and
// a second copy of that fact is a second thing to get wrong. `povOverride` is
// the deliberate escape hatch (?pov=first on the street, or Act 4's pull from
// first to third).
export function usePov() {
  const interior = useWorldStore((s) => s.interior);
  const override = useWorldStore((s) => s.povOverride);
  if (override) return override;
  return interior && ROOMS[interior]?.firstPerson ? 'first' : 'third';
}

// THE EARN-YOUR-BODY RULE, asked as a question.
//
// Three presence tiers: a guest is a soft figure, a member with no track is a
// pill and a profile image, and a member with a track gets a rigged body. Only
// the last one has hands — so only the last one can hold a phone, and everyone
// else keeps it in the HUD.
//
// Deliberately the SAME test <Peers/> uses to decide whether to render a rigged
// body at all (a roster entry with `rigged`), because a phone floating where a
// body isn't is worse than a phone in the corner.
export function useHasBody() {
  const myAvatarId = useWorldStore((s) => s.myAvatarId);
  const npcList = useWorldStore((s) => s.npcList);
  if (!myAvatarId) return false;
  return (npcList || []).some((n) => n.avatarId === myAvatarId && n.rigged);
}

export default usePov;
